import i18n from 'locales/i18n';

export type StrengthPasswordType = {
  hasFragility: boolean;
  fragilities: {
    key: string;
    T: string;
    done: boolean;
  }[];
};

export function checkPasswordStrength(password: string): StrengthPasswordType {
  const fragilities = [
    {
      key: 'uppercase',
      T: i18n.t('change_password:uppercase_error'),
      done: false,
    },
    {
      key: 'lowercase',
      T: i18n.t('change_password:lowercase_error'),
      done: false,
    },
    {
      key: 'number',
      T: i18n.t('change_password:number_error'),
      done: false,
    },
    {
      key: 'character',
      T: i18n.t('change_password:character_error'),
      done: false,
    },
    {
      key: 'length',
      T: i18n.t('change_password:length_error'),
      done: false,
    },
  ];

  const upperCaseRegex = new RegExp(/^(?=.*[A-Z])/);
  const lowerCaseRegex = new RegExp(/^(?=.*[a-z])/);
  const numberCaseRegex = new RegExp(/^(?=.*[0-9])/);
  const characterCaseRegex = new RegExp(/^(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\])/);
  const lengthRegex = new RegExp(/^(?=.{6,})/);

  function updateFragility(index: string) {
    const objIndex = fragilities.findIndex(({ key }) => key === index);
    fragilities[objIndex].done = true;
  }

  if (upperCaseRegex.test(password)) {
    updateFragility('uppercase');
  }
  if (lowerCaseRegex.test(password)) {
    updateFragility('lowercase');
  }
  if (numberCaseRegex.test(password)) {
    updateFragility('number');
  }
  if (characterCaseRegex.test(password)) {
    updateFragility('character');
  }
  if (lengthRegex.test(password)) {
    updateFragility('length');
  }

  const hasFragility = fragilities.some((f) => f.done === false);

  return { hasFragility, fragilities };
}
